import React from "react";

const PHONE_RE = /(?:\+?\d[\d\s\-()]{7,}\d)/g;

const normalizeTelHref = (raw) => {
    const digits = String(raw || "").replace(/[^\d+]/g, "");
    if (!digits) return "";
    if (digits.startsWith("+")) return `tel:${digits}`;
    if (digits.startsWith("0") && digits.length >= 10) return `tel:+38${digits}`;
    if (digits.startsWith("380") && digits.length >= 12) return `tel:+${digits}`;
    return `tel:${digits}`;
};

/** Split text and wrap phone-like fragments in tel: links. */
export function linkifyPhoneText(text) {
    const raw = String(text || "");
    if (!raw) return "Без опису";

    const parts = [];
    let lastIndex = 0;
    let match;
    const re = new RegExp(PHONE_RE);
    while ((match = re.exec(raw)) !== null) {
        const value = match[0];
        if (match.index > lastIndex) {
            parts.push(raw.slice(lastIndex, match.index));
        }
        const href = normalizeTelHref(value);
        parts.push(
            href ? (
                <a key={`tel-${match.index}`} href={href} className="wr-phone-link">
                    {value}
                </a>
            ) : value
        );
        lastIndex = match.index + value.length;
    }
    if (lastIndex < raw.length) {
        parts.push(raw.slice(lastIndex));
    }
    return parts.length ? parts : raw;
}
